import React, { useContext, useState } from 'react'
import { GlobalContext } from '../GlobalContext'
import CloudformationOutputs from '../CloudformationOutputs.json'
import Modal from '../ui-elements/Modal'
import FormatAssetName from './FormatAssetName'

type Props = {
    question: ObjectStringKeyAnyValue
    classString: string
}


type AssetNameProps = {
    assetId: string
    assetName?: string
}

function AssetName({
    assetId,
    assetName
}: AssetNameProps) {
    const { t } = useContext(GlobalContext)
    if (assetName) {
        return <>{t('Dashboard.FormatQuestionTitle.assetName', { assetName, assetId })} <span className={`text-xs font-sans italic text-gray-600`}>(#{assetId})</span></>
    } else {
        return <>{t('Dashboard.FormatQuestionTitle.assetId', { assetId })}</>
    }
}


function FormatQuestionTitle({
    question,
    classString
}: Props) {
    const { t, tableData } = useContext(GlobalContext)

    if (!question) {
        return null
    }

    const assetId = question.AssetId || question.FridgeId
    const assetName = assetId && tableData && tableData.Assets && tableData.Assets[assetId] && tableData.Assets[assetId].AssetName

    if (question.AssetId && question.QuestionFormat === 'AssetReading') {
        return <p className={classString}>
            {t('Dashboard.FormatQuestionTitle.readingFor')} <AssetName assetId={assetId} assetName={assetName} />
        </p>
    }
    else if (assetId && question.QuestionFormat === 'PhotoAndReading') {
        return <p className={classString}>
            {t('Dashboard.FormatQuestionTitle.photoAndReadingFor')} <AssetName assetId={assetId} assetName={assetName} />
        </p>
    }
    else if (question.FridgeId && question.QuestionFormat === 'FridgeTemperature') {
        return <p className={classString}>
            {t('Dashboard.FormatQuestionTitle.temperatureReadingFor')} <AssetName assetId={assetId} assetName={assetName} />
        </p>
    }
    else {
        return <p className={classString}>{t('Dashboard.FormatQuestionTitle.questionText', { text: question.QuestionText })}</p>
    }

}
    
export default FormatQuestionTitle